import { useEffect } from 'react';
import { useNavigation } from 'react-router';

import { markNavigationPending } from 'providers/navigationPending';

/**
 * Dates each navigation from the moment it was requested, for whoever needs to tell a navigation the
 * reader just caused apart from one they made a while ago.
 *
 * Separate from `NotificationProvider`, which is what wants the answer, because `useNavigation` only works
 * under a data router — the provider is mounted under one in the app but not in tests or Storybook, where
 * reading it would throw. Those trees go without the signal rather than failing to render.
 */
const NavigationPendingReporter = () => {
  const { state } = useNavigation();

  useEffect(() => {
    if (state === 'loading') {
      markNavigationPending();
    }
  }, [state]);

  return null;
};

export default NavigationPendingReporter;
